import * as brands from "./brands";
import * as categories from "./categories";
import * as giftcards from "./giftcards";
import * as orders from "./orders";

export const gshop = {
    ...brands,
    ...categories,
    ...giftcards,
    ...orders
}